import { render, staticRenderFns } from "./DetailCommission.vue?vue&type=template&id=3f57db5d&scoped=true&"
import script from "./DetailCommission.vue?vue&type=script&lang=js&"
export * from "./DetailCommission.vue?vue&type=script&lang=js&"
import style0 from "./DetailCommission.vue?vue&type=style&index=0&id=3f57db5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57db5d",
  null
  
)

export default component.exports